import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateText',
})
export class TruncateText implements PipeTransform {
  transform(text: string, quantityAllowed: number) {
    let truncatedText = text;

    if (Number(quantityAllowed) && text) {
      if (text.split('').length > quantityAllowed) {
        truncatedText = text.trim().substring(0, quantityAllowed) + ' . .';
      }
    }

    return truncatedText;
  }
}
